var map = {
	"./about-bg-png-x2.webp": 44781,
	"./about-details.webp": 65797,
	"./about-devices-pngx2.webp": 52592,
	"./about-gradient-pink-turquoise.webp": 28708,
	"./about/logo-agoric.webp": 11570,
	"./about/logo-aib.webp": 40353,
	"./about/logo-alter.webp": 81341,
	"./about/logo-andromeda.webp": 20806,
	"./about/logo-architech.webp": 8114,
	"./about/logo-archway.webp": 7570,
	"./about/logo-axelar.webp": 98260,
	"./about/logo-bitcanna.webp": 6465,
	"./about/logo-bonus-block.webp": 87114,
	"./about/logo-crypto-chemistry.webp": 4441,
	"./about/logo-cudos.webp": 11739,
	"./about/logo-decentr.webp": 65692,
	"./about/logo-empowerchain.webp": 13963,
	"./about/logo-gravity-bridge.webp": 71771,
	"./about/logo-inter-protocol.webp": 91854,
	"./about/logo-jackal.webp": 85061,
	"./about/logo-kado.webp": 35698,
	"./about/logo-kelepar.webp": 89343,
	"./about/logo-kusama-kingdom.webp": 79841,
	"./about/logo-landslide.webp": 25019,
	"./about/logo-liquid-finance.webp": 75044,
	"./about/logo-living-opera.webp": 60364,
	"./about/logo-luckyfriday.webp": 55902,
	"./about/logo-nibiru.webp": 21750,
	"./about/logo-phi-labs.webp": 90069,
	"./about/logo-qwoyn-studios.webp": 41189,
	"./about/logo-silvermine-capital.webp": 33124,
	"./about/logo-sky-consulting.webp": 26379,
	"./about/logo-synaps.webp": 65623,
	"./about/logo-vidulum.webp": 28169,
	"./about/logo-xavier-capital.webp": 91491,
	"./default-welcome-dialog-bg.webp": 65278,
	"./help/dashboard/Picture1.webp": 12043,
	"./help/dashboard/Picture10.webp": 36077,
	"./help/dashboard/Picture11.webp": 80514,
	"./help/dashboard/Picture12.webp": 45411,
	"./help/dashboard/Picture13.webp": 62368,
	"./help/dashboard/Picture14.webp": 63385,
	"./help/dashboard/Picture15.webp": 68702,
	"./help/dashboard/Picture16.webp": 61951,
	"./help/dashboard/Picture17.webp": 83708,
	"./help/dashboard/Picture18.webp": 33045,
	"./help/dashboard/Picture19.webp": 65514,
	"./help/dashboard/Picture2.webp": 59626,
	"./help/dashboard/Picture20.webp": 86742,
	"./help/dashboard/Picture21.webp": 51473,
	"./help/dashboard/Picture22.webp": 70484,
	"./help/dashboard/Picture23.webp": 12343,
	"./help/dashboard/Picture3.webp": 27157,
	"./help/dashboard/Picture4.webp": 11076,
	"./help/dashboard/Picture5.webp": 25255,
	"./help/dashboard/Picture6.webp": 82918,
	"./help/dashboard/Picture7.webp": 52673,
	"./help/dashboard/Picture8.webp": 72832,
	"./help/dashboard/Picture9.webp": 55875,
	"./help/dashboard/logo-gravitate-white.svg": 76239,
	"./help/dashboard/missing-image-1.png": 95184,
	"./help/dashboard/missing-image-2.png": 66475,
	"./help/dashboard/missing-image-3.png": 45346,
	"./help/dashboard/missing-image-4.png": 49597,
	"./help/dashboard/missing-image-5.png": 16564,
	"./help/dashboard/missing-image-6.png": 7407,
	"./help/dashboard/missing-image-7.png": 68390,
	"./help/pool/Picture1.webp": 61999,
	"./help/pool/Picture10.webp": 25577,
	"./help/pool/Picture11.webp": 86478,
	"./help/pool/Picture12.webp": 45775,
	"./help/pool/Picture13.webp": 4908,
	"./help/pool/Picture14.webp": 17085,
	"./help/pool/Picture15.webp": 65746,
	"./help/pool/Picture16.webp": 19,
	"./help/pool/Picture17.webp": 74256,
	"./help/pool/Picture18.webp": 10289,
	"./help/pool/Picture19.webp": 53014,
	"./help/pool/Picture2.webp": 8654,
	"./help/pool/Picture20.webp": 11202,
	"./help/pool/Picture21.webp": 36141,
	"./help/pool/Picture22.webp": 57824,
	"./help/pool/Picture23.webp": 11523,
	"./help/pool/Picture24.webp": 95166,
	"./help/pool/Picture25.webp": 79673,
	"./help/pool/Picture26.webp": 79164,
	"./help/pool/Picture27.webp": 7103,
	"./help/pool/Picture28.webp": 71466,
	"./help/pool/Picture29.webp": 92085,
	"./help/pool/Picture3.webp": 78377,
	"./help/pool/Picture4.webp": 47952,
	"./help/pool/Picture5.webp": 58387,
	"./help/pool/Picture6.webp": 96690,
	"./help/pool/Picture7.webp": 56605,
	"./help/pool/Picture8.webp": 42132,
	"./help/pool/Picture9.webp": 26839,
	"./help/trade/Picture1.webp": 88865,
	"./help/trade/Picture10.webp": 54847,
	"./help/trade/Picture11.webp": 76604,
	"./help/trade/Picture12.webp": 56281,
	"./help/trade/Picture13.webp": 45246,
	"./help/trade/Picture14.webp": 38307,
	"./help/trade/Picture15.webp": 55264,
	"./help/trade/Picture16-cancelled.webp": 33127,
	"./help/trade/Picture16.webp": 28973,
	"./help/trade/Picture17.webp": 73410,
	"./help/trade/Picture18.webp": 24039,
	"./help/trade/Picture2.webp": 68228,
	"./help/trade/Picture3.webp": 38279,
	"./help/trade/Picture4.webp": 38794,
	"./help/trade/Picture5.webp": 84309,
	"./help/trade/Picture6.webp": 91880,
	"./help/trade/Picture7.webp": 31787,
	"./help/trade/Picture8.webp": 19966,
	"./help/trade/Picture9.webp": 61401,
	"./help/wallet/Picture1.webp": 60830,
	"./help/wallet/Picture2.webp": 54079,
	"./help/wallet/Picture3.webp": 75836,
	"./help/wallet/Picture4.webp": 28205,
	"./help/wallet/Picture5.webp": 72642,
	"./help/wallet/Picture6.webp": 37539,
	"./loader-ellipse.svg": 6687,
	"./loader.svg": 85586,
	"./sale-bg.png": 34388,
	"./social_001.png": 89750,
	"./trade-bg-mobile-2x.webp": 49249,
	"./trade-bg.webp": 59231,
	"./white-noise-x1.webp": 26611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;